import { CONFIG } from '@arrived/config';
import { DemioEvent } from '@arrived/models';

import { demioApi } from './api';

export interface DemioEventRequest {
  type?: 'upcoming' | 'past' | string;

  /**
   * Whether to return upcoming or past events
   */
  active?: boolean;
}

/**
 * @api https://publicdemioapi.docs.apiary.io/#reference/events/events-list/events-list
 */
export const getDemioEvents = async ({ type = 'upcoming', active = false }: DemioEventRequest) => {
  try {
    const response = await demioApi.get<DemioEvent[]>('/events', {
      params: {
        type,
        active,
        // TODO: Not keeping this, temporary solution till we get a backend service
        api_key: CONFIG.demio.apiKey,
        api_secret: CONFIG.demio.apiSecret,
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching demio events', error);

    return [];
  }
};

export interface DemioRegisterRequest {
  id: number;
  ref_url?: string | null;
  date_id?: number;
  name: string;
  email: string;
}

export interface DemioRegisterResponse {
  hash: string;
  join_link: string;
}

export const registerDemioEvent = async (data: DemioRegisterRequest) => {
  try {
    const response = await demioApi.post<DemioRegisterResponse>('/event/register', data, {
      params: {
        api_key: CONFIG.demio.apiKey,
        api_secret: CONFIG.demio.apiSecret,
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error registering demio event', error);

    return {} as DemioRegisterResponse;
  }
};
